<app-crudbar-nav [title]="title" (onReady)="doComReady($event,'crudbar-nav')">
</app-crudbar-nav>

<mat-tab-group #masterTabGroup mat-stretch-tabs="false" mat-align-tabs="start"
  class="h-full"
  style="vertical-align: top;" animationDuration="0ms" dynamicHeight
  (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myTabGrid label="瀏覽">
    <div class="border-2 border-red-300">
      <app-jkaggrid #myGrid  [columnDefs]="srv.columnDefs" 
        (afterGridReadyAg)="afterGridReady($event)" (rowClicked)="agRowClicked($event)"
        (rowSelected)="agRowSelected($event)" (onInsert)="doUIInsert($event)"
        (onDelete)="doUIDelete($event)"></app-jkaggrid>

    </div>
  </mat-tab>

  <mat-tab #myTabDetail label="明細">
    <!-- <app-utysb-tabedit [srv]="srv"></app-utysb-tabedit> -->
    <div style="max-height: 400px; overflow-y: auto;">
      <div class="jk-grid-cols-2">
          <app-jktextarea  height="250px" 
 label="欄位排序" #SQLORDERCom  id="SQLORDER"  [(value)]="item.SQLORDER" [readonly]="true"     >
    </app-jktextarea>
    <app-jktext  label="保留6" [value]="item.SB105"     >
    </app-jktext>
    <app-jktext  label="保留5" [value]="item.SB104"     >
    </app-jktext>
    <app-jktext  label="保留4" [value]="item.SB103"     >
    </app-jktext>
    <app-jktextarea  height="250px" 
 label="保留3" #SB102Com  id="SB102"  [(value)]="item.SB102" [readonly]="true"     >
    </app-jktextarea>
    <app-jktextarea  height="250px" 
 label="保留2" #SB101Com  id="SB101"  [(value)]="item.SB101" [readonly]="true"     >
    </app-jktextarea>
    <app-jktextarea  height="250px" 
 label="保留1" #SB100Com  id="SB100"  [(value)]="item.SB100" [readonly]="true"     >
    </app-jktextarea>
    <app-jktextarea  height="250px" 
 label="SQLReturn" #SQLRETURNCom  id="SQLRETURN"  [(value)]="item.SQLRETURN" [readonly]="true"     >
    </app-jktextarea>
    <app-jktext  label="主資料表" [value]="item.MAINTABLE"     >
    </app-jktext>
    <app-jktextarea  height="250px" 
 label="WHERE參數設定" #MAPCom  id="MAP"  [(value)]="item.MAP" [readonly]="true"     >
    </app-jktextarea>
    <app-jktextarea  height="250px" 
 label="顯示" #DISPLAYCom  id="DISPLAY"  [(value)]="item.DISPLAY" [readonly]="true"     >
    </app-jktextarea>
    <app-jktextarea  height="250px" 
 label="備註" #PSCom  id="PS"  [(value)]="item.PS" [readonly]="true"     >
    </app-jktextarea>
    <app-jktextarea  height="250px" 
 label="SQLWhere" #SQLWHERECom  id="SQLWHERE"  [(value)]="item.SQLWHERE" [readonly]="true"     >
    </app-jktextarea>
    <app-jktextarea  height="250px" 
 label="SQLSelect" #SQLSELECTCom  id="SQLSELECT"  [(value)]="item.SQLSELECT" [readonly]="true"     >
    </app-jktextarea>
    <app-jktext  label="標題" [value]="item.TITLE"     >
    </app-jktext>
    <app-jktext  label="類別" [value]="item.TYPE"     >
    </app-jktext>
    <app-jktext  label="序號" [value]="item.ITEM"     >
    </app-jktext>

      </div>
    </div>
  </mat-tab>


  <mat-tab #myTabAdvance label="進階">
    <div class="border-2 min-h-[200px]">[空白]</div>
  </mat-tab>
</mat-tab-group>